import { Poll } from '@lessonup/teaching-core';
import classNames from 'classnames';
import React from 'react';
import './RealtimePollEmojis.less';

interface Props {
  pollItem: Poll.Emoji;
  pollAnswer?: number;
  handleSubmitAnswer?: (answer: number) => Promise<void>;
}

const RealtimePollEmojis: React.FC<Props> = (props) => {
  const { handleSubmitAnswer, pollAnswer, pollItem } = props;

  return (
    <div className="emoji-wrapper">
      {pollItem.options.map((emoji, i) => (
        <PollEmojiInput
          key={i}
          emoji={emoji}
          answer={i}
          handleSubmitAnswer={handleSubmitAnswer}
          isActive={!handleSubmitAnswer && !pollAnswer ? true : i === pollAnswer}
        />
      ))}
    </div>
  );
};

export default RealtimePollEmojis;

type PollEmojiProps = {
  isActive: boolean;
  emoji: string;
  handleSubmitAnswer?: (answer: number) => Promise<void>;
  answer: number;
};

const PollEmojiInput: React.FC<PollEmojiProps> = ({ isActive, emoji, handleSubmitAnswer, answer }) => {
  const handleClick = () => {
    handleSubmitAnswer && handleSubmitAnswer(answer);
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- auto-generated TECH-258
    <span onClick={handleClick} className={classNames('emoji', isActive && 'active')}>
      {emoji}
    </span>
  );
};
